<template>
  <!--此部分根据设计自动生成，手动修改节点标记daltag="manual"属性，则该节点及子节点不会被自动生成代码覆盖，如发现其他需要调整框架情形请联系:alex.c@daline.com.cn-->
  <div id="NewInformation" style="width:100vw">
    <div id="aa6e5d34">
      <div id="a05a8d5c">
        <div id="aa885d71">资讯标题</div>
        <el-input id="a2d23c46" v-model="inp_a2d23c46"> </el-input>
      </div>
      <div id="a3aa8083">
        <div id="f70df040">封面</div>
        <el-upload
          id="a24d51cc"
          class="f4dd4555"
          action="/R17771874636-PU-UPLOADSERVER-V0X0X1/pu?type=QueryData&fidx=uploadFile"
          :http-request="uploadfengmianImg"
          :show-file-list="false"
          :on-success="updsuc_f4dd4555"
          :before-upload="updbefor_f4dd4555"
          multiple
        >
          <img id="imga24d51cc" v-if="imgurl_f4dd4555" :src="imgurl_f4dd4555" />
        </el-upload>
      </div>

      <div id="a3aa8083">
        <div id="f70df040">文章banner图</div>
        <el-upload
          id="a24d51cc"
          action="/R17771874636-PU-UPLOADSERVER-V0X0X1/pu?type=QueryData&fidx=uploadFile"
          :http-request="uploadbannerImg"
          :show-file-list="false"
          :on-success="updsuc_articleBnner"
          :before-upload="updbefor_articleBnner"
          multiple
        >
          <img
            id="imga24d51cc"
            v-if="imgurl_articleBnner"
            :src="imgurl_articleBnner"
          />
        </el-upload>
      </div>
      <div id="a86a491e">
        <div id="aedd7bd4">类别</div>
        <el-select
          id="a90fadf4"
          placeholder="请选择类别"
          v-model="val_a90fadf4"
        >
          <el-option
            v-for="item in op_a90fadf4"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div class="a6d29288">
        <div id="e22d03bd">是否置顶</div>
        <el-radio-group id="ab13ec11" v-model="rdg_ab13ec11">
          <el-radio id="adcc9a70" label="0">否 </el-radio>
          <el-radio id="f2898226" label="1">是 </el-radio>
        </el-radio-group>
      </div>
      <div id="a9a05e31">
        <div id="a3f56e98">状态</div>
        <el-select
          id="a49eba36"
          placeholder="请选择状态"
          v-model="val_a49eba36"
        >
          <el-option
            v-for="item in op_a49eba36"
            :key="item.label"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </div>
      <div id="articleSummary">
        <div id="cb275e01">文章摘要</div>
        <!-- <el-input id="a2d23c46" v-model="inp_articleSummary">
      </el-input> -->
        <textarea v-model="inp_articleSummary" id="inputtextarea"></textarea>
      </div>
      <div id="aa52d6c7">
        <div class="videolist">
          现有视频列表
          <el-button
            @click="clickaddnewvideo()"
            class="tag-read"
            style="margin-left: 300px"
            >新增视频
          </el-button>
          <el-table :data="videolist_data">
            <el-table-column prop="a687e057" label="视频名字">
            </el-table-column>
            <el-table-column prop="cc7cb36c" label="视频地址" width="300px">
            </el-table-column>
            <el-table-column prop="复制" label="复制">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  :data-clipboard-text="scope.row.cc7cb36c"
                  @click="clickurl(scope.row)"
                  class="tag-read"
                  >复制
                </el-button>
              </template>
            </el-table-column>
            <el-table-column prop="a0a8e060" label="上传时间">
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div id="fd85f122">
        <div id="cb275e01">资讯内容</div>
        <el-form>
          <el-form-item>
            <quill-editor
              v-model="content"
              ref="myQuillEditor"
              :options="editorOption"
               @ready="ready($event)"
              @change="onEditorChange($event)"
            >
            </quill-editor>
          </el-form-item>
          <form
            action
            method="post"
            enctype="multipart/form-data"
            id="uploadFormMulti"
          >
            <input
              style="display: none"
              :id="uniqueId"
              type="file"
              name="file"
              multiple
              accept="image/jpg, image/jpeg, image/png, image/gif"
              @change="uploadImg('uploadFormMulti')"
              :on-success="upScuccess"
            />
          </form>
        </el-form>
        <!-- <div id="b5eadcbf" ref="ref_b5eadcbf">
      </div> -->
      </div>
      <div id="bf155d4b">
        <el-button id="a83a5af0" @click="clicka83a5af0()"> 保存 </el-button>
        <el-button id="a77b3ded" @click="clicka77b3ded()"> 取消 </el-button>
      </div>
      <div
        id="dlgfac269b5e"
        v-show="vis_ac269b5e"
        @click.self="vis_ac269b5e = true"
      >
        <div id="ac269b5e">
          <div id="a948dfbe">上传至微信公众号</div>
          <div id="a44db007">是否上传至微信公众号</div>
          <div id="a9654b99">
            <el-button id="a4e642a3" @click="clicka4e642a3()"> 确认 </el-button>
            <el-button id="a64cc16f" @click="clicka64cc16f()"> 取消 </el-button>
          </div>
        </div>
      </div>
      <div
        id="dlgaddnewvideo"
        v-show="vis_addnewvideo"
        @click.self="vis_addnewvideo = true"
      >
        <div id="addnewvideo">
          视频名字<el-input v-model="videoname" style="width: 500px"></el-input>
          <el-button size="small" type="primary" @click="clicksavenewvideo()"
            >保存视频</el-button
          >
        </div>
        <div id="d94e1f74">
          文章视频
          <el-upload
            class="myuploadVideo"
            action="/R17771874636-PU-UPLOADSERVER-V0X0X1/pu?type=QueryData&fidx=uploadFile"
            :http-request="Upload"
            :before-upload="beforeAvatarUpload"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-success="handleSuccess"
            :on-exceed="handleExceed"
            :show-file-list="true"
            multiple
            :limit="1"
            :on-change="handleChange"
            :file-list="fileList"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
              <em>点击上传</em>
            </div>
            <div slot="tip" class="el-upload__tip">上传文件大小不能超过 1G</div>
            <el-progress
              class="uploadProcess"
              v-show="showProgress"
              :text-inside="true"
              :stroke-width="15"
              :percentage="progress"
            ></el-progress>
          </el-upload>
        </div>
        <el-button size="small" type="primary" @click="clickcanceladd()"
          >取消</el-button
        >
      </div>
    </div>
  </div>
</template>
<script>
//此文件根据设计自动生成编写框架，请在指定位置编写逻辑代码，如发现框架需要调整的情形请联系:alex.c@daline.com.cn
//在此注释下方添加自定义import
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import {lineHeightStyle}  from '../quill/lineHeight'
import video from '../quill/video'
Quill.register(video,true)
import Quill from "quill";
import {
  DALINEWEB_ARTICLECENTER_V0X0X1_addArticle,
  DALINEWEB_WXPUBLICCENTER_V0X0X1_addnewmaterial,
  DALINEWEB_IMGCENTER_V0X0X1_getImgList,
  DALINEWEB_IMGCENTER_V0X0X1_addImg
  // DALINEWEB_WXPUBLICCENTER_V0X0X1_getthumbmedia
} from '../api/dalapi.js'

import ImageResize from "quill-image-resize-module"; // 引用
import  {ImageDrop}  from "quill-image-drop-module";
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize); // 注册
var fonts = ['SimSun', 'SimHei','Microsoft-YaHei','KaiTi','FangSong','Arial','Times-New-Roman','sans-serif'];
var Font = Quill.import('formats/font');
let fontSizeStyle = Quill.import('attributors/style/size')
Font.whitelist = fonts; //将字体加入到白名单
fontSizeStyle.whitelist = ["18px","20px","22px","24px","26px","28px","30px","32px","36px","40px"]
Quill.register(Font, true);
Quill.register(fontSizeStyle, true);
// 工具栏配置
const toolbarOptions = [
        ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线 -----['bold', 'italic', 'underline', 'strike']
        ["blockquote", "code-block"], // 引用  代码块-----['blockquote', 'code-block']
        [{ header: 1 }, { header: 2 }], // 1、2 级标题-----[{ header: 1 }, { header: 2 }]
        [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表-----[{ list: 'ordered' }, { list: 'bullet' }]
        [{ script: "sub" }, { script: "super" }], // 上标/下标-----[{ script: 'sub' }, { script: 'super' }]
        [{ indent: "-1" }, { indent: "+1" }], // 缩进-----[{ indent: '-1' }, { indent: '+1' }]
        [{ direction: "rtl" }], // 文本方向-----[{'direction': 'rtl'}]
        // [{ size: ["small", false, "large", "huge"] }], // 字体大小-----[{ size: ['small', false, 'large', 'huge'] }]
        [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题-----[{ header: [1, 2, 3, 4, 5, 6, false] }]
        [{ color: [] }, { background: [] },{ size: fontSizeStyle.whitelist }], // 字体颜色、字体背景颜色-----[{ color: [] }, { background: [] }]
        [{ font: [] }], // 字体种类-----[{ font: [] }]
        [{ align: [] }], // 对齐方式-----[{ align: [] }]
        ["clean"], // 清除文本格式-----['clean']
        ["image", "video"], // 链接、图片、视频-----['link', 'image', 'video']
        [{ lineheight: ["1", "1.5", "1.75", "2", "3", "4", "5"] }], // 对齐方式
        [{ 'font': fonts }],
      ]
import http from "@/api/restful.js";
import { client,getFileNameUUID } from "@/api/ali-oss"; //前面的ali-js文件内的两个封装函数
//在此注释下方添加自定义函数
//此注释下方为自动引用部分，请不要修改
import dal_editor from "wangeditor"
import dal_rest from "@/api/restful.js"
import Clipboard from 'clipboard'
// let edt_ref_b5eadcbf = null
export default{
  components:{
    quillEditor
    },
  data(){
    return{
      imgurl_articleBnner:'',
      imgurl_f4dd4555: "",
      inp_a2d23c46:"",
      op_a90fadf4:[
        {value: 167,label: '私域流量建设'},
        {value: 169,label: '数字资产化'},
        {value: 41,label: '一体化业务开发平台'},
        {value: 87,label: '关于我们'},
        {value: -2,label: '新闻中心'},
        // {value: 1,label: '企业简介'},
        {value: 168,label: '私域流量建设(解决方案)'},
        {value: 170,label: '数字资产化(解决方案)'},
        {label:"公司招聘",value:2},
        {label:"产品案例",value:171}
      ],
      val_a90fadf4:"",
      rdg_ab13ec11:'',
      rd_adcc9a70:'',
      rd_f2898226:'',
      op_a49eba36:[
        {value: 0,label: '使用'},
        {value: 2,label: '停用'}
      ],
      val_a49eba36:'',
      ref_b5eadcbf:'',
        //在此注释下方添加自定义变量
      dialogImageUrl: '',
      dialogVisible: false,
      imgurl: '',
      imgList: [],
      newFlg: true,
      fileList:[],
      videoURL:'',
      vis_ac269b5e:false,
      vis_addnewvideo:'',
      newHtml:'',
      inp_articleSummary:'',
      showProgress:false,
      progress:0,
      content:'',
      videolist_data:[],
      videoname:'',
      editorOption: { placeholder: '', theme: 'snow',
                    modules: {
                       //工具栏定义的
                    toolbar: {container:toolbarOptions,
                              handlers: {
                              lineheight: (value) => {
                                if (value) {
                                  let quill = this.$refs.myQuillEditor.quill;
                                  quill.format("lineHeight", value);
                                }
                                },
                                },
                              },
                    imageDrop: true,
                    imageResize: {
                      displayStyles: {
                        backgroundColor: "black",
                        border: "none",
                        color: "white"
                      },
                      modules: ["Resize", "DisplaySize", "Toolbar"]
                    },
                    history: {
                      delay: 1000,
                      maxStack: 50,
                      userOnly: false,
                    },
                    }
                    },
      uniqueId:'uniqueId',
    }
  },
  mounted(){
    // this.getaliimgurl()
        this.getvideolist()
        var _this = this;
        var imgHandler = async function(image) {

        if (image) {
        var fileInput = document.getElementById(_this.uniqueId); //隐藏的file文本ID
        fileInput.click(); //加一个触发事件
        }
        };
        _this.editor.getModule("toolbar").addHandler("image", imgHandler);
        },

  computed:{
     editor() {
      return this.$refs.myQuillEditor.quill;
    }
  },
  watch:{
  },
  methods:{
    clickurl(data){
      console.log("row.cc7cb36c",data.cc7cb36c);
        let clipboard = new Clipboard('.tag-read')
        clipboard.on('success', e => {
            console.log('复制成功',e)
            //  释放内存
          // clipboard.destory()
        })
    },
    ready() {
      Quill.register({ "formats/lineHeight": lineHeightStyle }, true);
    },
    onEditorChange() {
       console.log("a") },
    uploadfengmianImg(file){
    const that = this;
    async function multipartUpload() {
        let temporary = file.file.name.lastIndexOf(".");
        let fileNameLength = file.file.name.length;
        let fileFormat = file.file.name.substring(
          temporary + 1,
          fileNameLength
        );
        let fileName = getFileNameUUID() + "." + fileFormat;
        client()
          .multipartUpload(`DalineWeb/${fileName}`, file.file, {
            progress: function (p) {
              //p进度条的值
              console.log(p);
            },
          })
          .then((result) => {
            //上传成功返回值，可针对项目需求写其他逻辑
            that.imgurl_f4dd4555 = "https://store.daline.com.cn/prod/dalineweb/daloss/" + result.name
            console.log(that.imgurl_f4dd4555);
          })
          .catch((err) => {
            console.log("err:", err);
          });
      }
      multipartUpload();
    },
    uploadImg: async function(){
         console.log("tup");
      let _this = this;
      //构造formData对象
      let fd = new FormData();
      fd.append("file",document.getElementById(_this.uniqueId).files[0] );
      // fd.append("file", document.getElementById(_this.uniqueId).files[0]);
            let uploadURL =
          "/R17771874636-PU-UPLOADSERVER-V0X0X1/pu?type=QueryData&fidx=uploadFile";
      try {
        //调用上传文件接口
        await http
          .post(uploadURL, fd, {
            headers: { "Content-Type": "multipart/form-data" },
            baseURL: "/dalgw",
          }).then(res => {
          //返回上传文件的地址
          let url = res.content.url;
          console.log(url,"diyige");
          if (url != null && url.length > 0) {
            let Range = _this.editor.getSelection();
            url = url.indexOf("http") != -1 ? url : "http:" + url;
            console.log(url,"dierge");
            //上传文件成功之后在富文本中回显(显示)
            _this.editor.insertEmbed(
              Range != null ? Range.index : 0,
              "image",
              url
            );
          } else {
            _this.$message.warning("图片上传失败");
          }
          //成功之后,将文件的文本框的value置空
          document.getElementById(_this.uniqueId).value = "";
        });
      } catch ({ message: msg }) {
        document.getElementById(_this.uniqueId).value = "";
        _this.$message.warning(msg);
      }
    },
    upScuccess(res) {
        const quill = this.$refs.myQuillEditor.quill
        if (res.code === 200 && res.data !== null) {
            const length = quill.getSelection().index // 获取光标所在位置
            quill.insertEmbed(length, 'image', res.data.url) // 插入图片
            quill.setSelection(length + 1) // 调整光标位置到最后
        } else {
            this.$message.error('图片上传失败')
        }
    },
    getaliimgurl(){
    this.edt_ref_b5eadcbf = new dal_editor(this.$refs.ref_b5eadcbf)
    this.edt_ref_b5eadcbf.config.uploadImgMaxLength = 1
    this.edt_ref_b5eadcbf.config.zIndex = 1
    this.edt_ref_b5eadcbf.config.height = 1418
    this.edt_ref_b5eadcbf.config.showLinkVideo = false
    this.edt_ref_b5eadcbf.config.showFullScreen  = true
    this.edt_ref_b5eadcbf.config.placeholder  = ""

    this.edt_ref_b5eadcbf.config.customUploadVideo  = function (resultFiles, insertVideoFn) {
    // resultFiles 是 input 中选中的文件列表
    // insertVideoFn 是获取视频 url 后，插入到编辑器的方法
    client().put('myVideo', resultFiles[0])
      .then(function (res) {
        // 上传视频，返回结果，将视频插入到编辑器中
        insertVideoFn(res.url)
        console.log("a");
      }).catch(function (err) {
        console.log(err)
      })
      }
    this.edt_ref_b5eadcbf.config.customUploadImg = function (resultFiles, insertImgFn) {
    // resultFiles 是 input 中选中的文件列表
    // insertImgFn 是获取图片 url 后，插入到编辑器的方法
    client().put('myImg', resultFiles[0])
      .then(function (res) {
        // 上传图片，返回结果，将图片插入到编辑器中
        insertImgFn(res.url)
      }).catch(function (err) {
        console.log(err)
      })
      }
    this.edt_ref_b5eadcbf.create()
    this.edt_ref_b5eadcbf.txt.html(this.$route.query.articleContent)
    },
    getwximgurl(imgFile){
      let fd = new FormData();
      let fileURL = "";
      fd.append("file", imgFile);
            let wxuploadURL =
          "/DALINEWEB-PU-WXPUBLICCENTER-V0X0X1/pu?fidx=getthumbmedia&type=QueryData&media_type=image";
       dal_rest
      .post(wxuploadURL, fd, {
        headers: { "Content-Type": "multipart/form-data","keepAlive":true },
        baseURL: "/dalgw",
      })
      .then(
        (res) => {
          console.log("上传成功", res);
          let wximgurl = res.content.url;
          // insertImgFn(wximgurl)
          console.log(wximgurl,"wximgurl");
        },
        (err) => {
          console.log("上传失败", err);
          this.$message("上传失败");
        })
        return fileURL;
    },
    updsuc_f4dd4555(res, file) {
      console.log('成功回调结果', res)
      console.log('成功回调结果file', file)
      this.imgurl_f4dd4555 = URL.createObjectURL(file.raw);
    },
    async getFileURL(imgFile) {
      let fd = new FormData();
      let fileURL = "";
      fd.append("file", imgFile);
      let uploadURL =
          "/R17771874636-PU-UPLOADSERVER-V0X0X1/pu?type=QueryData&fidx=uploadFile";
       await http
          .post(uploadURL, fd, {
            headers: { "Content-Type": "multipart/form-data" },
            baseURL: "/dalgw",
          })
          .then(
              (res) => {
                console.log("上传成功111", res);
                fileURL = res.content.url;
                if (this.imgType == 5) {
                  this.imgurl_f4dd4555 = fileURL;
                } else {
                  this.imgurl_a4220463 = fileURL;
                }
              },
              (err) => {
                console.log("上传失败", err);
                this.$message("上传失败");
              }
          );
          console.log(uploadURL,"auploadURL");
          return fileURL;
    },
    updbefor_f4dd4555(file) {
      console.log('imagefile', file)
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG.PNG 格式!");
      } else {
        if (!isLt2M) {
          this.$message.error("上传头像图片大小不能超过 20MB!");
        }
        // else {
        //   this.imgType = 5;
        //   this.getFileURL(file);
        // }
      }
      return isJPG && isLt2M;
    },
    updbefor_articleBnner(file) {
      console.log('imagefile', file)
      const isJPG = file.type === "image/jpeg" || "image/png";
      const isLt2M = file.size / 1024 / 1024 < 20;
      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG.PNG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 20MB!");
      }
    },
    uploadbannerImg(file){
    const that = this;
    async function multipartUpload() {
        let temporary = file.file.name.lastIndexOf(".");
        let fileNameLength = file.file.name.length;
        let fileFormat = file.file.name.substring(
          temporary + 1,
          fileNameLength
        );
        let fileName = getFileNameUUID() + "." + fileFormat;
        client()
          .multipartUpload(`DalineWeb/${fileName}`, file.file, {
            progress: function (p) {
              //p进度条的值
              console.log(p);
            },
          })
          .then((result) => {
            //上传成功返回值，可针对项目需求写其他逻辑
            that.imgurl_articleBnner = "https://store.daline.com.cn/prod/dalineweb/daloss/" + result.name
            console.log(that.imgurl_articleBnner);
          })
          .catch((err) => {
            console.log("err:", err);
          });
      }
      multipartUpload();
    },
    updsuc_articleBnner(res, file) {
      console.log('成功回调结果', res)
      console.log('成功回调结果file', file)
      this.imgurl_articleBnner = URL.createObjectURL(file.raw);
    },
    async clicka83a5af0(){
    let dicInput = {
      // articleContent: this.edt_ref_b5eadcbf.$textContainerElem.elems[0].innerHTML,
      articleContent: this.content,
      authorName: "数字智能"}
      if(this.inp_a2d23c46 === undefined || this.inp_a2d23c46 == ""){
        this.$message("请输入文章名")
        return
      }else{
        dicInput.articleTitle = this.inp_a2d23c46
      }
      if(this.val_a90fadf4 === undefined || this.val_a90fadf4 == ""){
        this.$message("请选择文章类型")
        return
      }else{
        dicInput.articleType = this.val_a90fadf4
      }
        switch(this.val_a49eba36){
        case "停用":
        this.val_a49eba36 = 1
        break
        case "使用":
        this.val_a49eba36 = 0
        break
        case "":
        this.val_a49eba36 = 0
        break}
      dicInput.top = this.rdg_ab13ec11 == '' ? 0 :this.rdg_ab13ec11,
      dicInput.status = this.val_a49eba36,
      dicInput.articleImg = this.imgurl_f4dd4555 == undefined ? 0 :this.imgurl_f4dd4555,
      dicInput.articleSummary = this.inp_articleSummary
      dicInput.articleBnner = this.imgurl_articleBnner
      console.log(dicInput);
        const res = await DALINEWEB_ARTICLECENTER_V0X0X1_addArticle(dicInput,"post")
        const retcontent = JSON.parse(JSON.stringify(res.retContent))
        const data = JSON.parse(retcontent.retContent)
        if (data.resCode === 0) {
          this.$message.success('发布文章成功')
          this.vis_ac269b5e = true
           this.$router.push('Information')
        } else {
          this.$message.error('发布文章失败')
        }
    },
    async clicka77b3ded(){
      this.$router.push('Information')
    },
    //在此注释下方添加自定义函数或事件
    handleChange(file, fileList) {
      console.log("handleChange", file, fileList);
      this.fileList = [{ name: file.name }];
    },

    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      console.log("handleExceed", files, fileList);
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {
      console.log("handlePreview", file);
    },
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      console.log(fileList);
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {
      console.log(file, fileList);
      this.progress=0
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      this.fileList = fileList;
    },
        //文件上传前的校验
    async beforeAvatarUpload(file) {
      const isLt100M =
        file.size / 1024 / 1024 > 1 && file.size / 1024 / 1024 < 1024;
      const isLt30 = file.name.length < 30;
      if (["video/mp4"].indexOf(file.type) == -1) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
      if (!isLt100M) {
        this.$message.error("上传视频大小要在10MB~1GB之间哦!");
        return false;
      }
      if (!isLt30) {
        this.$message.error("上传视频文件名称长度必须要小于30个文字哦!");
        return false;
      }
      return true},

    //上传视频生成视频路径
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现
    Upload(file) {
      const that = this;
      async function multipartUpload() {
        let temporary = file.file.name.lastIndexOf(".");
        let fileNameLength = file.file.name.length;
        let fileFormat = file.file.name.substring(
          temporary + 1,
          fileNameLength
        );
        let fileName = getFileNameUUID() + "." + fileFormat;
        client()
          .multipartUpload(`Wechat-XHT/FutureSchool/${fileName}`, file.file, {
            progress: function (p) {
              //p进度条的值
              console.log(p);
              that.showProgress = true;
              that.progress = Math.floor(p * 100);
            },
          })
          .then((result) => {
            //上传成功返回值，可针对项目需求写其他逻辑
            // console.log("oss res",result);
            that.videoURL = "https://store.daline.com.cn/prod/dalineweb/daloss/" + result.name
            console.log(that.videoURL);
          })
          .catch((err) => {
            console.log("err:", err);
          });
      }
      multipartUpload();
    },

    async clicka4e642a3(){
      let dicInput = {author:"数字智能", media_type :"thumb",}
      dicInput.title = this.inp_a2d23c46,
      dicInput.media_file_ul = this.imgurl_f4dd4555
      dicInput.digest = ""
      dicInput.show_cover_pic = 1
      dicInput.content =  this.edt_ref_b5eadcbf.$textContainerElem.elems[0].innerHTML
      const res = await DALINEWEB_WXPUBLICCENTER_V0X0X1_addnewmaterial(dicInput,"post")
      console.log(res,"888");
      if(res.retCode === 0){
        this.vis_ac269b5e = false
        this.$router.push('Information')
      }
    },
    async clicka64cc16f(){
      this.vis_ac269b5e = false
        this.$router.push('Information')
    },
    getwximgurledt(){
          // 上传至微信公众号后台
    // this.edt_ref_for_wx = new dal_editor(this.$refs.ref_b5eadcbf)
    // this.edt_ref_for_wx.config.uploadImgMaxLength = 1
    // this.edt_ref_for_wx.config.zIndex = 1
    // this.edt_ref_for_wx.config.height = 418
    // this.edt_ref_for_wx.config.customUploadImg = (resultFiles, insertwxImgFn) => {
    //   let fd = new FormData();
    //   let wximgurl = "";
    //   fd.append("file", resultFiles[0]);
    //   console.log(fd,"ppppp");
    //   let uploadURL =
    //       "/DALINEWEB-PU-WXPUBLICCENTER-V0X0X1/pu?fidx=getthumbmedia&type=QueryData&media_type=image";
    //    dal_rest
    //   .post(uploadURL, fd, {
    //     headers: { "Content-Type": "multipart/form-data","keepAlive":true },
    //     baseURL: "/dalgw",
    //   })
    //   .then(
    //     (res) => {
    //       console.log("上传结果", res);
    //       let wximgurl = res.content.url;
    //       // insertwxImgFn(wximgurl)
    //       console.log(wximgurl,"ref_for_wx",insertwxImgFn);
    //     },
    //     (err) => {
    //       console.log("上传失败", err);
    //       this.$message("上传失败");
    //     })
    //     return wximgurl;
    // }
    // this.edt_ref_for_wx.create()
    // this.edt_ref_for_wx.txt.html(this.$route.query.articleContent)
    },
    async clickaddnewvideo(){
      this.vis_addnewvideo = true
    },
    async clickcanceladd(){
      this.vis_addnewvideo = false
    },
    async clicksavenewvideo(){
      let dicinput = {
        imgName: this.videoname,
        imgType: 1,
      }
      if (this.videoURL) {
        dicinput.imgURL = this.videoURL
      }else{
        this.$message("视频地址为空")
        return
      }
      const res = await DALINEWEB_IMGCENTER_V0X0X1_addImg(dicinput);
      let addres = JSON.stringify(res.retContent)
      console.log(addres);
      this.getvideolist()
     },
    async getvideolist() {
      const resImgList = await DALINEWEB_IMGCENTER_V0X0X1_getImgList({
        imgType: 1,
      });
      const videodataList = JSON.parse(JSON.stringify(resImgList.retContent));
      this.videodataList = JSON.parse(videodataList.retContent).imgList
      let temp = []
      this.videodataList.forEach(element => {
        temp.push({
        a687e057 : element.imgName,
        cc7cb36c : element.imgURL,
        a0a8e060 : element.insertTime
        })
      });
      this.videolist_data = temp
      }

  }
}
</script>
<style>
/*此部分根据设计自动生成，自定义样式追加到该部分结尾处*/

#aa6e5d34 {
  /* width:1649px; */
  position: relative;
  padding-bottom: 223px;
}
#a05a8d5c {
  width: 588px;
  position: relative;
  padding-left: 70px;
  padding-top: 216px;
}
#aa885d71 {
  padding-top: 13px;
  padding-bottom: 13px;
  display: inline-block;
  vertical-align: middle;
}
#aa885d71 {
  text-align: left;
  color: #333;
  font-size: 13px;
  font-family: PingFang SC;
}
#a05a8d5c .el-input {
  width: 436px;
  margin-left: 100px;
  display: inline-block;
  vertical-align: middle;
}
#a3aa8083 {
  position: relative;
  margin-top: 38px;
  padding-left: 70px;
}
#f70df040 {
  width: 90px;
  padding-top: 13px;
  display: inline-block;
  vertical-align: middle;
}
#f70df040 {
  text-align: left;
  color: #333;
  font-size: 13px;
  font-family: PingFang SC;
}
#a24d51cc {
  width: 130px;
  height: 168px;
  margin-left: 126px;
  display: inline-block;
  vertical-align: middle;
}
#a24d51cc .el-upload {
  position: absolute;
  height: 168px;
  width: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
}
#a24d51cc .el-upload:hover {
  border-color: #409eff;
}
#imga24d51cc {
  width: 100%;
  height: 100%;
  display: block;
}
#a24d51cc .icona24d51cc {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
#a86a491e {
  width: 588px;
  position: relative;
  margin-top: 22px;
  padding-left: 70px;
}
#aedd7bd4 {
  padding-top: 13px;
  padding-bottom: 13px;
  display: inline-block;
  vertical-align: middle;
}
#aedd7bd4 {
  text-align: left;
  color: #333;
  font-size: 13px;
  font-family: PingFang SC;
}
#a86a491e .el-select {
  width: 436px;
  margin-left: 126px;
}
.a6d29288 {
  width: 328px;
  position: relative;
  margin-top: 43px;
  padding-left: 71px;
  display: flex;
}
#e22d03bd {
  display: inline-block;
  vertical-align: middle;
}
#e22d03bd {
  text-align: left;
  color: #333;
  font-size: 13px;
  font-family: PingFang SC;
}
#ab13ec11 {
  width: 177px;
  margin-left: 99px;
  /* display:inline-block; */
  vertical-align: middle;
}
#ab13ec11 {
  width: auto;
  display: flex;
  vertical-align: middle;
}
#adcc9a70 {
  width: 41px;
  display: inline-block;
  vertical-align: middle;
}
#f2898226 {
  width: 41px;
  /* margin-left:95px; */
  display: inline-block;
  vertical-align: middle;
}
#a9a05e31 {
  width: 588px;
  position: relative;
  margin-top: 43px;
  padding-left: 70px;
}
#a3f56e98 {
  padding-top: 13px;
  padding-bottom: 13px;
  display: inline-block;
  vertical-align: middle;
}
#a3f56e98 {
  text-align: left;
  color: #333;
  font-size: 13px;
  font-family: PingFang SC;
}
#a9a05e31 .el-select {
  width: 436px;
  margin-left: 126px;
}
#fd85f122 {
  width: 1218px;
  position: relative;
  margin-top: 43px;
  padding-left: 70px;
}
#cb275e01 {
  /* padding-bottom:182px; */
  display: inline-block;
  vertical-align: middle;
}
#cb275e01 {
  text-align: left;
  color: #333;
  font-size: 13px;
  font-family: PingFang SC;
}
#b5eadcbf {
  width: 1218px;
  margin-left: 100px;
  display: inline-block;
  vertical-align: middle;
}
#bf155d4b {
  width: 344px;
  position: relative;
  margin-top: 60px;
  padding-left: 220px;
}
#a83a5af0 {
  width: 142px;
  display: inline-block;
  vertical-align: middle;
}
#a83a5af0 {
  background-color: rgb(20, 22, 32, 1);
  border-radius: 0px 0px 0px 0px;
}
#a83a5af0 {
  color: #fff;
  font-size: 14px;
  font-family: PingFang SC;
  border: transparent;
}
#a77b3ded {
  width: 142px;
  margin-left: 60px;
  display: inline-block;
  vertical-align: middle;
}
#a77b3ded {
  background-color: rgb(153, 153, 153, 1);
  border-radius: 0px 0px 0px 0px;
}
#a77b3ded {
  color: #fff;
  font-size: 14px;
  font-family: PingFang SC;
  border: transparent;
}
/*在此注释下方添加自定义样式*/
.myuploadVideo {
  padding-left: 125px;
  padding-top: 30px;
}
#dlgfac269b5e {
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
}
#dlgaddnewvideo {
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  bottom: 0;
  left: 300;
  width: 600px;
  height: 400px;
  background: aliceblue;
}
#ac269b5e {
  position: absolute;
  top: 294px;
  left: 676px;
  width: 660px;
  height: 237px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
}
#a948dfbe {
  width: 103px;
  padding-left: 30px;
  padding-top: 30px;
}
#a948dfbe {
  width: auto;
  color: #333;
  font-size: 24px;
  font-family: PingFang SC;
}
#a44db007 {
  width: 130px;
  margin-top: 43px;
  padding-left: 265px;
}
#a44db007 {
  width: auto;
  color: #333;
  font-size: 13px;
  font-family: PingFang SC;
}
#a9654b99 {
  width: 404px;
  position: relative;
  margin-top: 53px;
  padding-left: 128px;
  padding-bottom: 30px;
}
#a4e642a3 {
  width: 142px;
  display: inline-block;
  vertical-align: middle;
}
#a4e642a3 {
  background-color: #d10024;
  border-radius: 0px 0px 0px 0px;
}
#a4e642a3 {
  color: #fff;
  font-size: 14px;
  font-family: PingFang SC;
  border: transparent;
}
#a64cc16f {
  width: 142px;
  margin-left: 120px;
  display: inline-block;
  vertical-align: middle;
}
#a64cc16f {
  background-color: #999;
  border-radius: 0px 0px 0px 0px;
}
#a64cc16f {
  color: #fff;
  font-size: 14px;
  font-family: PingFang SC;
  border: transparent;
}
#articleSummary {
  width: 500px;
  padding-left: 70px;
  padding-top: 30px;
}
#inputtextarea {
  width: 500px;
  height: 150px;
  border: solid 0.5px;
  margin-left: 150px;
}
.editor {
  line-height: normal !important;
  height: 500px;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "18px";
}
/* .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
} */
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
  content: "20px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22px"]::before {
  content: "22px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="24px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="24px"]::before {
  content: "24px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="26px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="26px"]::before {
  content: "26px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="28px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
  content: "28px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {
  content: "30px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="32px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="32px"]::before {
  content: "32px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="36px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="36px"]::before {
  content: "36px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="40px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="40px"]::before {
  content: "40px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-label::before {
  content: "行高";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="1"]::before {
  content: "1";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="1.5"]::before {
  content: "1.5";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="1.75"]::before {
  content: "1.75";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="2"]::before {
  content: "2";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="3"]::before {
  content: "3";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="4"]::before {
  content: "4";
}
.ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value="5"]::before {
  content: "5";
}
.ql-snow .ql-picker.ql-lineheight {
  width: 70px;
}
#aa52d6c7 {
  width: 800px;
  padding-left: 100px;
  padding-top: 50px;
}
#addnewvideo {
  margin-left: 10px;
  padding-top: 40px;
}
#addnewvideo.el-input {
  padding-left: 55px;
}
#d94e1f74 {
  flex: 1;
}
</style>
